import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { Fragment as m } from "react";
import { useChatbotContext as g } from "../../hooks/useChatbotContext.js";
import { BotMessage as c } from "./BotMessage.js";
import { BotMessageContainer as d } from "./BotMessageContainer.js";
import { BotMessageHeader as l } from "./BotMessageHeader.js";
import { BotMessageLayout as f } from "./BotMessageLayout.js";
import { BotMessageMarkdown as p } from "./BotMessageMarkdown.js";
import { Messages as u } from "./Messages.js";
function F({ unwrapped: n }) {
  const { chatbot: r, chatError: t, hydrateError: s, isBuilder: o } = g(), a = ((o ? s == null ? void 0 : s.message : null) ?? (o ? t == null ? void 0 : t.message : null) ?? (r == null ? void 0 : r.customErrorMessage) ?? "Unable to load Chatbot").replace("[FRIENDLY_ERROR]:", "").trim();
  return /* @__PURE__ */ e(n ? m : u, { children: /* @__PURE__ */ e(f, { children: /* @__PURE__ */ i(d, { children: [
    /* @__PURE__ */ e(
      l,
      {
        index: 0,
        message: {
          id: "error-message",
          role: "assistant",
          content: a,
          createdAt: /* @__PURE__ */ new Date()
        },
        showFeedback: !1
      }
    ),
    /* @__PURE__ */ e(c, { className: "bg-destructive text-destructive-foreground ring-offset-destructive [&_a:hover]:!bg-transparent [&_a:hover]:!text-current [&_a]:!ring-offset-destructive", children: /* @__PURE__ */ e(p, { simulateStream: !0, children: a }) })
  ] }) }) });
}
export {
  F as ErrorMessage
};
